import Accruals from "../components/Accruals/Accruals";
import Accrual from "../components/Accruals/Accrual";
import {PERM} from "../utilites/permissions";

const accruals = [
  {
    path: '/accruals',
    name: 'Accruals',
    component: Accruals,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
      ]
    },
    props: true,
  },
  {
    path: '/accruals/new',
    name: 'AccrualAdd',
    component: Accrual,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
        PERM.STAFF_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/accruals/edit/:id',
    name: 'AccrualEdit',
    component: Accrual,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
        PERM.STAFF_EDIT,
      ]
    },
    props: true
  },
];

export default accruals;



// WEBPACK FOOTER //
// ./src/router/accruals.js